export default function COUNTBLANK() {
  return <div>Excel_COUNTBLANK</div>;
}
